import React, { Component } from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import './App.css';
import axios from 'axios';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import IOTTemp from './TempGauge/TempGauge';
import FanSwitch from './FanSwitch/FanSwitch';
import SignInForm from './SignIn/SignIn';
import Details from './Details/Details';
import AWS from 'aws-sdk';
import VideoPlayer from './Video/Video';

const baseURL = process.env.REACT_APP_API_URL;
console.log(`Initializing from baseURL:${baseURL}.`);
let videoUrl = 'https://devstreaming-cdn.apple.com/videos/streaming/examples/img_bipbop_adv_example_fmp4/master.m3u8';

class App extends Component {

  constructor(props) {
    super(props);
    console.log(`App constructor called`);

    this.state = {
      fan_state: false,
      temp: 0,
      device: 'exp-iot-1',
      authToken: ''
    }

    axios.interceptors.response.use(function (response) {
      return response;
    }, (error) => {
      if(error.response && error.response.status === 403) {
        console.log(`Auth error: ${error.response.status}`);
        clearInterval(this.interval); // Terminate REST calls
        alert('Your authorization token has expired. Please sign in.')
        window.location.reload(false); // Re-initialize app, including video stream
      }
      return Promise.reject(error);
    });
  }

  onChangeHandler = (state) => {
    console.log(`onChangeHandler called, state: ${state}`);
    (async () => {
      try {
        const response = await axios({
          method: 'patch',
          url: `${baseURL}/api/devices/${this.state.device}`,
          data: {
            fan_state: state
          }
        })
        console.log(response);
        this.setState({ fan_state: state })
        } catch(error) {
          console.log(error);

        }
    })(); 
  }


  onAuthHandler = (token) => {
    console.log('onAuthHandler received token:', token);
    // Add token to authorization header for all REST requests
    axios.defaults.headers.common['Authorization'] = token;
    this.setState({ authToken: token });

    (async () => {
      try {
        const response = await axios.get(`${baseURL}/api/devices/${this.state.device}`);
        console.log(response);
        this.setState({ temp: response.data.temp });
        this.setState({ fan_state: response.data.fan_state })
        } catch(error) {
          console.log(error);

        }
    })();

    this.interval = setInterval( () => {
        (async () => {
          try {
            const response = await axios.get(`${baseURL}/api/devices/${this.state.device}`);
            console.log(response);
            this.setState({ temp: response.data.temp });
            this.setState({ fan_state: response.data.fan_state })
            } catch(error) {
              console.log(error);

            }
        })() 
      }, 15000); // milliseconds 
  }
  
  componentDidMount() {
    console.log('componentDidMount called.');

    const options = {
      accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
      secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
      region: process.env.REACT_APP_AWS_REGION
    }

    const kinesisVideo = new AWS.KinesisVideo(options);
    const kinesisVideoArchivedMedia = new AWS.KinesisVideoArchivedMedia(options);

    kinesisVideo.getDataEndpoint({ 
        StreamName: process.env.REACT_APP_AWS_STREAM,
        APIName: "GET_HLS_STREAMING_SESSION_URL"
      }, function(err, response) {
        if (err) { return console.error(err); }
        console.log('Data endpoint: ' + response.DataEndpoint);   
        kinesisVideoArchivedMedia.endpoint = new AWS.Endpoint(response.DataEndpoint);
        kinesisVideoArchivedMedia.getHLSStreamingSessionURL({
          StreamName: process.env.REACT_APP_AWS_STREAM,
          PlaybackMode: 'LIVE',
          ContainerFormat: 'FRAGMENTED_MP4',
          DiscontinuityMode: 'ALWAYS',
          DisplayFragmentTimestamp: 'NEVER',
          Expires: 10800
        }, function(err, response) {
          if (err) { return console.error("Could not retrieve URL", err); }
          console.log('HLS Streaming Session URL: ' + response.HLSStreamingSessionURL, response);
          videoUrl = response.HLSStreamingSessionURL;
        })
      })
  }

  componentWillUnmount() {
    console.log('componentWillUnmount called.');
    clearInterval(this.interval);
  }

  home = () => {
    return(
      <div className="container-fluid" id="top-container">
        <div className="row">
        {this.state.authToken.length > 0 ? 
           <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center col-centered">
              <IOTTemp temp={this.state.temp} />
              <FanSwitch fan_state={this.state.fan_state} onChange={this.onChangeHandler} />
              <VideoPlayer url={videoUrl} />
           </div> 
           :
           <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 col-centered">
             <SignInForm baseURL={baseURL} onAuth={this.onAuthHandler} />
           </div> 
         }
        </div>
      </div>
    )
  }
 
 // Route all requests to home page (login screen) until user is signed in
  render() {
    return (
      <Router>
        <div className="App">
          <div className="content-wrap">
            <Header device={this.state.device} />
            <Switch>
              <Route exact path="/" component={this.home}/>
              {this.state.authToken.length > 0 ? 
                <Route path="/details" component={Details}/>
              :
                <Route path="/details" component={this.home}/>
              }
            </Switch>
          </div>
          <Footer />
        </div>
      </Router>
    );
  }
}
  
export default App;
